import React from "react";
import { Controller } from "react-hook-form";
import {
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
} from "@material-ui/core";
import classnames from "classnames";

import { useFieldsStyles } from "../fields.styles";

import { RadioGroupProps } from "./radio-group.props";
import { makeKey } from "../../../../utils/helpers";

export const RadioGroup = (props: RadioGroupProps) => {
  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);

  const wrapperClasses = classnames({
    [commonClasses.fieldWrapper]: true,
  });

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <div className={wrapperClasses}>
          <FormLabel error={hasError} required={props.required}>
            {props.label}
          </FormLabel>
          <MuiRadioGroup {...renderProps.field} row={props.row}>
            {props.options.map((option, index) => (
              <FormControlLabel
                control={<Radio />}
                disabled={!canEdit}
                key={makeKey(option.value, index)}
                label={option.label}
                value={option.value}
              />
            ))}
          </MuiRadioGroup>

          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </div>
      )}
    />
  );
};
